import React from 'react';
import styled, { css } from 'styled-components';
import { FontStyle } from '../../../styles/FontStyle';
import { MobileScreen } from '../../../styles/ConstantMediaQuery';

const defaultProps = {
    description: null,
    infos: [],
    styles: {},
};

const ModalHeaderDescription = ({ description, infos, styles }) => (
    <Wrapper>
        {infos.length > 0 && (
            <InfoList>
                {infos.map(({ label, value }) => (
                    <InfoItem key={`${value}-${label}`}>
                        <InfoLabel styles={styles.infoLabel}>{label}:</InfoLabel>
                        <InfoValue styles={styles.infoValue}>{value}</InfoValue>
                    </InfoItem>
                ))}
            </InfoList>
        )}
        {description && <Description styles={styles.description}>{description}</Description>}
    </Wrapper>
);

ModalHeaderDescription.defaultProps = defaultProps;

const genericTextStyle = css`
    ${FontStyle};
    color: #ffffff;
    font-size: 15px;

    ${({ styles }) => styles && { ...styles }};
`;

const InfoValue = styled.span`
    ${genericTextStyle};
`;

const InfoLabel = styled.span`
    ${genericTextStyle};
    font-weight: bold;
    padding-right: 5px;
`;

const InfoItem = styled.li`
    ${genericTextStyle};
`;

const InfoList = styled.ul`
    list-style: none;
    margin: 0 0 20px 0;
    padding: 0;
`;

const Description = styled.p`
    ${genericTextStyle};
    margin: 0;
    padding: 0;
    
    ${({ styles }) => styles && { ...styles }};
`;

const Wrapper = styled.div`
    max-width: 550px;
    position: relative;
    
    @media ${MobileScreen} {
        padding: 0 5vw;
        width: 100%;
    }
`;

export default ModalHeaderDescription;
